<template>
  <div class="news">
    <div
      class="
        slider
        position-absolute
        d-flex
        align-items-start
        justify-content-center
      "
    >
      <img
        src="../../assets/img/news/bg.png"
        alt=""
        srcset=""
        width="1920px"
        class="object-fit"
      />
    </div>
    <!-- news 内容 -->
    <div class="cont new-bg position-absolute">
      <div class="positon-relative w100 h100">
        <div class="list position-absolute">
          <div v-for="(item, index) in list" :key="index" class="cursor">
            <div
              class="d-flex align-items-center justify-content-between size-18"
              @click="handleDetail(item)"
            >
              <div class="line mr-12"></div>
              <div class="flex-1 line-clamp-1 mr-24">{{ item.title }}</div>
              <div>{{ common.tsformat(item.time) }}</div>
            </div>
          </div>
        </div>
        <div class="pagination position-absolute d-flex align-items-center">
          <div class="fl-arrow arrow mr-24 cursor" @click="prevNews()"></div>
          <div class="fr-arrow arrow cursor" @click="nextNews()"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      totalPage: 0,
      limit: 10,
      page: 1,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    handleDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/event",
        query: { id: item.id },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 获取新闻列表
    initData(take = 1) {
      const reqTime = Math.floor(new Date().getTime() / 1000);
      const gameId = APP_ID;
      const signature = this.common.makeSignature({ gameId }, reqTime);
      const params = { gameId, signature, reqTime };

      this.page = take;
      if (this.page > 1) params["page"] = this.page;

      // console.log("cid", cid, categoryId);
      this.$axios({
        method: "post",
        url: "news/query",
        data: params,
        //withCredentials:true, //局部携带cookie
        headers: {}, //如果需要添加请求头可在这写
      })
        .then((res) => {
          this.list = res.data.data.data;
          this.totalPage = Math.ceil(res.data.data.total / this.limit);
        })
        .catch((err) => {
          //请求失败就会捕获报错信息
          //err.response可拿到服务器返回的报错数据
        });
    },

    nextNews() {
      console.log(this.totalPage, this.page);

      if (this.page < this.totalPage) {
        this.initData(this.page + 1);
      } else {
        alert("No more content");
      }
    },

    prevNews() {
      if (this.page > 1) {
        this.initData(this.page - 1);
      } else {
        alert("No more content");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.cont {
  top: 79px;
  left: 50%;
  transform: translate(-50%, 0);
}
.new-bg {
  background: url("../../assets/img/news/news-bg.png") no-repeat center top;
  background-size: 100% 100%;
  width: 1554px;
  height: 838px;
  border: solid 2px #e9c57e;
  .list {
    width: 870px;
    top: 101px;
    right: 71px;
    font-family: MicrosoftYaHei;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #cfa267;
    line-height: 60px;
  }
  .line {
    width: 1px;
    height: 22px;
    background-color: #ffd49c;
    opacity: 0.2;
  }
  .pagination {
    bottom: 68px;
    left: 70%;
    transform: translate(-70%, 0);
  }
  .arrow {
    background: url("../../assets/img/news/arrow.png") no-repeat center top;
    background-size: 100% 100%;
    width: 84px;
    height: 19px;
  }
  .fr-arrow {
    transform: rotate(180deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/news.vue